import React from 'react';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import Phone from 'material-ui-icons/Phone'
import Email from 'material-ui-icons/Email'
// import GpsFixed from 'material-ui-icons/GpsFixed'
// import GpsNotFixed from 'material-ui-icons/GpsNotFixed'

const styles = (/*theme*/) => ({
  root: {
    display: 'flex',
  },
  list: {
    textAlign: 'left',
  },
  info: {
    textAlign: 'justify',
  },
  title: {
    margin: '10px 0',
  },
  icon: {
    position: 'relative',
    width: 16,
    height: 16,
    top: 4,
    marginRight: 3,
  }
});

class StartingInfo extends React.Component {
  state = {
    value: '',
  };

  // handleChange = (event, value) => {
  //   this.setState({ value });
  //   this.props.choiceHandler( value );
  // };

  render() {
    const {classes} = this.props;
    return (
      <div>
        {/* <Typography type='body1' className={classes.info}>El proceso de inscripción tiene varios pasos, y te encuentras en el primero de ellos:</Typography> */}
        <Typography type='headline' className={classes.title}>Registro</Typography>
        <Typography type='body1' className={classes.info}>
          Este es el formulario de registro de la Fase Previa de AF7 2019. Cubriendo este formulario tendrás acceso a
          nuestra oferta de alojamiento. <br /><br />
          Este formulario refleja los precios más actualizados. Las plazas son limitadas. ¡Daos prisa!<br /><br />
          <strong style={{color:'red'}}>Importante:</strong> <br /> 
          Debes completar el registro una vez por cada equipo que vaya a participar. ¡Si traes tres o más equipos hay un descuento!
          <br /><br />
          El registro lo gestiona BALUMA TRAVEL, agencia oficial de Arousa Fútbol 7. Ante cualquier duda, consulta o demanda de otros servicios, podéis contactar con ellos en:<br />
          <Phone className={classes.icon} />986 531 907<br />
          <Email className={classes.icon} />info@balumatravel.com<br /><br />
          Su horario es de Lunes a Viernes de 10 a 13:30 y de 16:30 a 20:30. Los Sábados de 10:00 a 13:30
    </Typography>
      </div>
    );
  }
}

// StartingInfo.propTypes = {};

export default withStyles(styles)(StartingInfo);


// WEBPACK FOOTER //
// ./src/components/StartingInfo.jsx